export default __webpack_public_path__ + "static/media/chart.62a4e8ea.png";